import { isPermittedRoute } from 'applications/GSP/shared/utils/router';

import type { UserRole } from 'applications/GSP/shared/types';
import type { RouteObject } from 'shared/types';

export function getRoutesByRole<Route extends RouteObject>(
  role: UserRole,
  routes: Route[],
  parentKey?: string,
): Route[] {
  return routes.reduce((accRoute: Route[], route) => {
    const key = route.path ?? parentKey;

    if (route.children && isPermittedRoute(role, key)) {
      return [
        ...accRoute,
        {
          ...route,
          children: getRoutesByRole(role, route.children, key),
        },
      ];
    }

    if (isPermittedRoute(role, key)) {
      return [...accRoute, route];
    }

    return [...accRoute];
  }, []);
}
